import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { array, bool, string } from 'prop-types';

import { MultiActionButton, SanitizedHtml, StrapiImg } from 'components';
import { getModalContent, isBreakpoint } from 'helpers';

const BookingBloc = ({ bookingBlocLoading, blocks, className = '' }) => {
  const isDesktop = isBreakpoint(1024);

  return (
    <>
      {!bookingBlocLoading &&
        blocks?.map((block, i) => (
          <div
            className={clsx('lg:h-fit lg:shadow-lg lg:rounded-xl lg:overflow-hidden print:hidden', className)}
            key={`bloc-cta-${i}`}
          >
            {block?.image && (
              <div className="hidden lg:block lg:w-full lg:h-36">
                <StrapiImg className="w-full h-full object-cover" image={block.image} />
              </div>
            )}

            <div className="flex flex-col items-center lg:py-4">
              <SanitizedHtml className="hidden lg:block lg:p-4" content={block.content} />
              <div>
                {!isEmpty(block?.cta) && (
                  <MultiActionButton
                    cta={block.cta[0]}
                    modalContent={(_, type) => getModalContent(block, i, type)}
                    index={i}
                    phoneIconButton={isDesktop ? false : true}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

BookingBloc.propTypes = {
  blocks: array,
  bookingBlocLoading: bool,
  className: string
};

export default BookingBloc;
